module.exports = __webpack_public_path__ + "media/images/chevron-down-hovered-8e82d46d8ce62d88f50864b04bea2f60.png";